import { render, staticRenderFns } from "./aspect-ratio-box.vue?vue&type=template&id=25bb50a8&scoped=true"
import script from "./aspect-ratio-box.vue?vue&type=script&lang=js"
export * from "./aspect-ratio-box.vue?vue&type=script&lang=js"
import style0 from "./aspect-ratio-box.vue?vue&type=style&index=0&id=25bb50a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bb50a8",
  null
  
)

export default component.exports